import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { PapiGallection } from '@wix/da-papi-types';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import BaseListItem from '../BaseListItem';
import BaseListCell from '../BaseListItem/BaseListCell';
import StatItem from '../../_partials/StatItem';
import PremiumGalleryActions from './_partials/PremiumGalleryActions';
import PremiumGalleryThumb from './_partials/PremiumGalleryThumb';
import PremiumGalleryPriceEdit from '../../_partials/PremiumGalleryPriceEdit';

import s from './PremiumGalleryListItem.scss';

interface Props {
  gallery: PapiGallection;
}

const PremiumGalleryListItem: FC<Props> = ({ gallery }) => {
  const { t } = useTranslation();
  const deviationsCount = gallery.totalItemCount ?? 0;
  const subscribersCount = gallery.premiumFolderData?.numSubscribers ?? 0;
  const viewUrl = Url.studioGallery(gallery.folderId);
  return (
    <BaseListItem>
      <BaseListCell>
        <PlainButtonOrLink href={viewUrl}>
          <PremiumGalleryThumb gallery={gallery} />
        </PlainButtonOrLink>
      </BaseListCell>
      <BaseListCell>
        <PlainButtonOrLink className={s['title']} href={viewUrl}>
          {gallery.name}
        </PlainButtonOrLink>
      </BaseListCell>
      <BaseListCell>
        <PremiumGalleryPriceEdit gallery={gallery} />
      </BaseListCell>
      <BaseListCell>
        <StatItem
          title={t('studio.products.premiumGalleries.stats.deviations')}
          value={deviationsCount}
          linkTo={deviationsCount > 0 ? viewUrl : undefined}
        />
      </BaseListCell>
      <BaseListCell>
        <StatItem
          title={t('studio.products.premiumGalleries.stats.supporters')}
          value={subscribersCount}
          linkTo={
            subscribersCount > 0
              ? Url.customerDashboard(gallery.premiumFolderData?.subproductId)
              : undefined
          }
        />
      </BaseListCell>
      <BaseListCell>
        <PremiumGalleryActions gallery={gallery} />
      </BaseListCell>
    </BaseListItem>
  );
};
PremiumGalleryListItem.displayName = 'PremiumGalleryListItem';

export default PremiumGalleryListItem;
